
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Provider Component
 * @param response has the backend
 * Provider component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        providers: [],
        error: undefined
    }

    const { log } = context;
    if (response && response.status >= 400) {
        result.error = response;
    }
    if (response?.length > 0) {
        result.providers = response;
    }
    log.debug(
        "ccw-gadget,getallproviders-athena",
        "getallproviders-athena transformation response ", {
        result
    });
    return result;
}

